<template>
	<el-popover placement="bottom" width="300" trigger="hover" popper-class="popover-sound-setting">
		<div class="container">
			<div class="title">消息中心播放设置</div>
			<el-form ref="formRef" :rules="rules" :model="form" class="box-form">
				<el-form-item prop="soundDuration">
					<div class="content">
						声音播放时长:
						<el-input
							class="sound-input"
							v-model="form.soundDuration"
							placeholder="请输入时长"
							@keyup.enter.native.stop="handleEnter"
							@blur="handleBlur"
						/>
						分钟
						<el-tooltip effect="dark" placement="top">
							<div slot="content">
								限一位小数，比如 0.1 * 60 = 6秒
								<br />
								最小可设置为0，表示不播报声音
								<br />
								最大可设置为525600，表示播放时长为1年
							</div>
							<i class="el-icon-info"></i>
						</el-tooltip>
					</div>
				</el-form-item>
				<el-form-item prop="popupOffHours">
					<div class="content">
						弹窗失效时长:
						<el-input
							class="sound-input"
							v-model="form.popupOffHours"
							placeholder="请输入时长"
							@keyup.enter.native.stop="handleEnter"
							@blur="handlePopupOffBlur"
						/>
						小时
						<el-tooltip effect="dark" placement="top">
							<div slot="content">
								设置后该时长内不弹出告警弹窗，也不播报声音
								<br />
								限整数，最小可设置为0，表示不关闭弹窗
								<br />
								最大可设置为8760，表示1年内不弹窗
							</div>
							<i class="el-icon-info"></i>
						</el-tooltip>
					</div>
					<div v-if="popupOffUntil" class="tip">
						弹窗关闭至：{{ dayjs(popupOffUntil).format('YYYY-MM-DD HH:mm') }}
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="reference" v-if="hasAlarmRecordsAuth" class="box-alarm" @click="handleJump">
			<i class="iconfont icon-lingdang" />
			<span v-show="alarmCount" class="alarm-count">{{ alarmCount }}</span>
		</div>
	</el-popover>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { ruleRequired, RULE_SOUND_DURATION, RULE_POPUP_OFF_HOURS } from '@/utils/rules'
import { apiSetStaffSoundDuration } from '@/apis/tenant.api.js'

export default {
	name: 'AlarmSetting',
	data() {
		return {
			form: {
				soundDuration: 10,
				popupOffHours: 0,
			},
			rules: {
				soundDuration: [ruleRequired('请输入声音播放时长'), RULE_SOUND_DURATION],
				popupOffHours: [ruleRequired('请输入弹窗失效时长'), RULE_POPUP_OFF_HOURS],
			},
		}
	},
	computed: {
		...mapGetters({
			alarmCount: 'alarmPush/alarmCount',
			soundDuration: 'alarmPush/soundDuration',
			popupOffHours: 'alarmPush/popupOffHours',
			popupOffUntil: 'alarmPush/popupOffUntil',
		}),
		hasAlarmRecordsAuth() {
			return this.$has('monitor:run:alarm-record:select')
		},
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		userInfo() {
			return this.$store.getters.userInfo
		},
	},
	watch: {
		'$store.state.alarmPush.soundDuration'(val) {
			this.form.soundDuration = val
		},
		'$store.state.alarmPush.popupOffHours'(val) {
			this.form.popupOffHours = val
		},
	},
	methods: {
		...mapMutations({
			setAlarmCount: 'alarmPush/SET_ALARM_COUNT',
		}),
		...mapActions({
			getSoundDuration: 'alarmPush/getSoundDuration',
			getPopupOff: 'alarmPush/getPopupOff',
			mockAlarmPush: 'alarmPush/mockAlarmPush',
		}),
		handleJump() {
			if (this.alarmCount) {
				this.setAlarmCount(0)
				this.$router.push({
					name: 'alarmRecords',
					params: {
						update: true,
					},
				})
			}
		},
		handleEnter(event) {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					event.target.blur()
				}
			})
		},

		handleBlur() {
			this.$refs.formRef.validate(valid => {
				if (!valid) {
					this.form.soundDuration = this.soundDuration
				} else {
					this.setSoundDuration()
				}
			})
		},

		setSoundDuration() {
			if (this.form.soundDuration == this.soundDuration) return
			const params = {
				configs: [{ key: 'alarm_sound_duration', value: this.form.soundDuration }],
				tenantId: this.tenantId,
				staffId: this.userInfo.staffId,
			}
			apiSetStaffSoundDuration(params).then(() => {
				this.$message.success('设置播放时长成功！')
				this.getSoundDuration()
			})
		},

		handlePopupOffBlur() {
			this.$refs.formRef.validateField('popupOffHours', errorMessage => {
				if (errorMessage) {
					this.form.popupOffHours = this.popupOffHours
				} else {
					this.setPopupOff()
				}
			})
		},

		setPopupOff() {
			const hours = Number(this.form.popupOffHours)
			// 时长未变且仍在生效中(或为0)时不重复设置,已过期的相同时长允许重新开始计时
			if (hours === this.popupOffHours && (hours === 0 || Date.now() < this.popupOffUntil)) return
			const params = {
				configs: [
					{ key: 'alarm_popup_off_hours', value: hours },
					{ key: 'alarm_popup_off_start', value: Date.now() },
				],
				tenantId: this.tenantId,
				staffId: this.userInfo.staffId,
			}
			apiSetStaffSoundDuration(params).then(() => {
				this.$message.success('设置弹窗失效时长成功！')
				this.getPopupOff()
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.box-alarm {
	margin-left: 26px;
	position: relative;
	.iconfont {
		font-size: 32px;
		color: #c1c6db;
		cursor: pointer;
	}
	.alarm-count {
		position: absolute;
		top: 0px;
		left: 50%;
		height: 16px;
		min-width: 16px;
		padding: 0 4px;
		border-radius: 8px;
		background: #e5662e;
		font-size: 12px;
		color: #fff;
		@include flex-center;
	}
}
</style>

<style lang="scss">
.el-popper.popover-sound-setting {
	padding: 0;
	border-radius: 5px;
	overflow: hidden;

	.popper__arrow {
		display: none;
	}

	.title {
		height: 40px;
		line-height: 40px;
		background-color: $base-color-theme;
		color: #fff;
		padding-left: 20px;
	}

	.box-form {
		padding: 20px;
	}

	.content {
		display: flex;
		align-items: center;

		.sound-input {
			margin-left: 20px;
			margin-right: 10px;
			flex: 1;
		}
	}

	.tip {
		font-size: 12px;
		line-height: 20px;
		color: #909399;
	}
}
</style>
